import { Flex } from 'foundations-components/components/Flex';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { useTicket } from '../../data/useTicket';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const InfoPanelHeader = ({
  ticketId
}) => {
  const {
    data: ticket
  } = useTicket(Number(ticketId));
  const contentValue = (ticket === null || ticket === void 0 ? void 0 : ticket['content']) || '';
  const hasValue = contentValue && contentValue.trim().length > 0;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: hasValue ? /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "50",
      children: /*#__PURE__*/_jsx(Paragraph, {
        marginBlockEnd: "0",
        color: "text-core-default",
        children: contentValue
      })
    }) : null
  });
};